// Angular Imports
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
// lodash
import { get as _get } from 'lodash';

// My Account Imports
import { GenericProductType, Policy } from '@amfam/policy/models';

import { PolicyChangeEmitter } from '../../models';
import { VehicleRiskDescription } from '../../models/change-request.model';

@Component({
  selector: 'app-plchangerequest-policy',
  templateUrl: './change-request-policy.component.html',
  styleUrls: ['./change-request-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChangeRequestPolicyComponent implements OnInit {
  // Inputs
  @Input() policy: Policy;
  @Input() changeRequestForm: UntypedFormGroup;
  @Input() isLastPolicy: boolean;
  @Input() policyControl: AbstractControl;
  @Input() policySelectionValue: boolean;

  // Outputs
  @Output() policyChanged = new EventEmitter<PolicyChangeEmitter>();

  public description: string[];
  public GenericProductType = GenericProductType;

  ngOnInit() {
    if (this.policy !== null) {
      this.description = this.policy.riskDescriptionList;
      const selected: boolean = this.getCurrentSelectionValue(
        this.policySelectionValue,
        this.description.length
      );
      if (selected) {
        this.policyControl.setValue(true);
        this.changed(this.description[0]);
      }
    }
  }

  private getCurrentSelectionValue(incomingSelection: boolean, risksLength = 0): boolean {
    return incomingSelection && risksLength <= 1;
  }

  public changed(riskDescription: string) {
    this.policyChanged.emit({
      policyNumber: this.policy.policyNumber,
      policyControlValue: this.policyControl.value,
      riskDescription: riskDescription
    });
  }
}
